type goToIntroPageCallback = { goToIntroPage: () => void }

export class ResultValueAndPage<TValue> {
    value?: TValue
    pageFunction: (arg0: goToIntroPageCallback) => React.JSX.Element

    constructor(pageFunction: (arg0: goToIntroPageCallback) => React.JSX.Element, value?: TValue) {
        this.pageFunction = pageFunction
        this.value = value
    }
}